import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Testimonial } from 'src/libs-common/models/testimonial.model';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TestimonialsService {
  headers = {
    'Content-Type': 'application/json'
  };

  testimonials$: Observable<Testimonial[]> | null = null

  constructor(private http: HttpClient) {
    this.testimonials$ = this.getTestimonials();
  }

  getTestimonials(): Observable<Testimonial[]> {
    return this.http.get<any>(environment.apiUrl + '/testimonials', {
      responseType: 'json',
      observe: 'body',
      headers: this.headers,
    }).pipe(
      // tap(_ => console.log('fetched testimonials')),
      catchError(this.handleError<Testimonial[]>('getTestimonials', [])),
      map(body => body.data)
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }



}

